//
// import {
//   type CaipNetworkId,
//   type ChainNamespace,
//   ConstantsUtil,
//   SafeLocalStorage,
//   type SafeLocalStorageItems,
//   SafeLocalStorageKeys
// } from '@reown/appkit-common'


import type { SIWXSession,  SIWXMessage, SIWXConfig} from "@reown/appkit-siwx";
import {DefaultSIWX,  SolanaVerifier} from "@reown/appkit-siwx";
import type {CaipNetworkId} from "@reown/appkit";

// https://github.com/reown-com/appkit/pull/4087/files/97e3c4d987a6fd3efb35d2e7583d7be041d20f82#diff-3b66b69edf8716b45274191ee31ad15609f6c53d234e3f0bb5ed2d2d86922879
// - [#4569](https://github.com/reown-com/appkit/pull/4569) [`a5870fa`](https://github.com/reown-com/appkit/commit/a5870fa6c87c9ce76bf1683543ddc325b04f0331) Thanks [@zoruka](https://github.com/zoruka)! - Introduce signOutOnDisconnect SIWXConfig flag and fix the same flag on SIWE that was not working properly.

export class ZenexAuthentication extends DefaultSIWX implements SIWXConfig{

  private listeners: ZenexAuthentication.EventListeners = {
    sessionChanged: []
  }


  // private readonly localAuthStorageKey: keyof SafeLocalStorageItems
  // private readonly localNonceStorageKey: keyof SafeLocalStorageItems
  //
  //
  // private listeners: ZenexAuthentication.EventListeners = {
  //   sessionChanged: []
  // }
  //
  // constructor(params?: Partial<SIWXConfig.ConstructorParams>) {
  //
  //   super({
  //     required : true,
  //     verifiers: [new SolanaVerifier()]
  //   })
  //
  //   // this.localAuthStorageKey =
  //   //   (params.localAuthStorageKey as keyof SafeLocalStorageItems) ||
  //   //   SafeLocalStorageKeys.SIWX_AUTH_TOKEN
  //   // this.localNonceStorageKey =
  //   //   (params.localNonceStorageKey as keyof SafeLocalStorageItems) ||
  //   //   SafeLocalStorageKeys.SIWX_NONCE_TOKEN
  //   //
  // }

  getRequired():boolean {
    return true
  }







  /**
   * Combine the verifiers to verify the session and storage to store it.
   * It will throw an error if the session is not valid.
   *
   * @param session SIWXSession
   * @returns Promise<void>
   */
  addSession(session: SIWXSession): Promise<void> {
    // console.log('za.addSession', session);
    this.emit('sessionChanged', session)
    return super.addSession(session);
  }
  /**
   * Combine the verifiers to verify the sessions and storage to store all of them.
   * It will throw an error if any of the sessions is not valid.
   *
   * @param chainId CaipNetworkId
   * @param address string
   * @returns Promise<SIWXSession[]>
   */
  async setSessions(sessions: SIWXSession[]): Promise<void> {
    // console.log('za.addSession', sessions);
    return super.setSessions(sessions);
  }
  /**
   * Get the sessions from the storage and verify them.
   * If the session is not valid, it will be removed from the storage.
   *
   * @param chainId CaipNetworkId
   * @param address string
   * @returns Promise<SIWXSession[]>
   */
  async getSessions(chainId: CaipNetworkId, address: string): Promise<SIWXSession[]>{
    // console.log('za.getSessions', chainId, address);

    const s = await super.getSessions(chainId, address)
    if (s){
      const currentSession = s.filter(
        (s) =>{
            return s?.data?.accountAddress === address && s?.data?.chainId === chainId;
        });

      if (currentSession.length === 1){
        this.emit('sessionChanged', currentSession[0])
        return currentSession;
      }
    }

    return [];
  }

  /**
   * Remove the session from the storage.
   *
   * @param chainId CaipNetworkId
   * @param address string
   * @returns Promise<void>
   */
  revokeSession(chainId: CaipNetworkId, address: string): Promise<void>{
    // console.log('za.revokeSession', chainId, address);
    return super.revokeSession(chainId, address);
  }
  /**
   * This method should verify the session.
   * It will first check if the verifier should verify the session and then call the verify method.
   * It will return `true` if the session is valid for all verifications and there is at least one verification.
   *
   * @param session SIWXSession
   * @returns Promise<boolean> - If `true` means the session is valid.
   */
  protected verifySession(session: SIWXSession): Promise<boolean>{
    // console.log('za.verifySession', session);
    return super.verifySession(session);
  }




  //
  // async addSession(session: SIWXSession): Promise<void> {
  //   const response = await this.request({
  //     method: 'POST',
  //     key: 'authenticate',
  //     body: {
  //       data: session.data,
  //       message: session.message,
  //       signature: session.signature,
  //       clientId: this.getClientId(),
  //       walletInfo: this.getWalletInfo()
  //     },
  //     headers: ['nonce', 'otp']
  //   })
  //
  //   this.setStorageToken(response.token, this.localAuthStorageKey)
  //   this.emit('sessionChanged', session)
  //   this.setAppKitAccountUser(jwtDecode(response.token))
  //
  //   this.otpUuid = null
  // }
  //
  // async getSessions(chainId: CaipNetworkId, address: string): Promise<SIWXSession[]> {
  //   try {
  //     if (!this.getStorageToken(this.localAuthStorageKey)) {
  //       return []
  //     }
  //
  //     const account = await this.request({
  //       method: 'GET',
  //       key: 'me',
  //       query: {},
  //       headers: ['auth'] as const
  //     })
  //
  //     if (!account) {
  //       return []
  //     }
  //
  //     const isSameAddress = account.address.toLowerCase() === address.toLowerCase()
  //     const isSameNetwork = account.caip2Network === chainId
  //
  //     if (!isSameAddress || !isSameNetwork) {
  //       return []
  //     }
  //
  //     const session: SIWXSession = {
  //       data: {
  //         accountAddress: account.address,
  //         chainId: account.caip2Network
  //       } as SIWXMessage.Data,
  //       message: '',
  //       signature: ''
  //     }
  //
  //     this.emit('sessionChanged', session)
  //     this.setAppKitAccountUser(account)
  //
  //     return [session]
  //   } catch {
  //     return []
  //   }
  // }
  //
  // async revokeSession(_chainId: CaipNetworkId, _address: string): Promise<void> {
  //   return Promise.resolve(this.clearStorageTokens())
  // }
  //
  // async setSessions(sessions: SIWXSession[]): Promise<void> {
  //   if (sessions.length === 0) {
  //     this.clearStorageTokens()
  //   } else {
  //     const session = (sessions.find(
  //       s => s.data.chainId === getActiveCaipNetwork()?.caipNetworkId
  //     ) || sessions[0]) as SIWXSession
  //
  //     await this.addSession(session)
  //   }
  // }

  //
  //
  // async getSessionAccount() {
  //   if (!this.getStorageToken(this.localAuthStorageKey)) {
  //     throw new Error('Not authenticated')
  //   }
  //
  //   return this.request({
  //     method: 'GET',
  //     key: 'me',
  //     body: undefined,
  //     query: {
  //       includeAppKitAccount: true
  //     },
  //     headers: ['auth']
  //   })
  // }
  //
  //
  on<Event extends keyof ZenexAuthentication.Events>(
    event: Event,
    callback: ZenexAuthentication.Listener<Event>
  ) {
    this.listeners[event].push(callback)

    return () => {
      this.listeners[event] = this.listeners[event].filter(
        cb => cb !== callback
      ) as ZenexAuthentication.EventListeners[Event]
    }
  }
  //
  // removeAllListeners() {
  //   const keys = Object.keys(this.listeners) as (keyof ZenexAuthentication.Events)[]
  //   keys.forEach(key => {
  //     this.listeners[key] = []
  //   })
  // }
  //
  //
  // private getStorageToken(key: keyof SafeLocalStorageItems): string | undefined {
  //   return SafeLocalStorage.getItem(key)
  // }
  //
  // private setStorageToken(token: string, key: keyof SafeLocalStorageItems): void {
  //   SafeLocalStorage.setItem(key, token)
  // }
  //
  // private clearStorageTokens(): void {
  //   this.otpUuid = null
  //   SafeLocalStorage.removeItem(this.localAuthStorageKey)
  //   SafeLocalStorage.removeItem(this.localNonceStorageKey)
  //   this.emit('sessionChanged', undefined)
  // }
  //
  //
  // private getClientId(): string | null {
  //   return BlockchainApiController.state.clientId
  // }
  //
  // private getWalletInfo(): ZenexAuthentication.WalletInfo | undefined {
  //   const walletInfo = ChainController.getAccountData()?.connectedWalletInfo
  //
  //   if (!walletInfo) {
  //     return undefined
  //   }
  //
  //   if ('social' in walletInfo && 'identifier' in walletInfo) {
  //     const social = walletInfo['social'] as string
  //     const identifier = walletInfo['identifier'] as string
  //
  //     return { type: 'social', social, identifier }
  //   }
  //
  //   const { name, icon } = walletInfo
  //
  //   let type: ZenexAuthentication.WalletInfo['type'] = 'unknown'
  //
  //   switch (walletInfo.type) {
  //     case 'EXTERNAL':
  //     case 'INJECTED':
  //     case 'ANNOUNCED':
  //       type = 'extension'
  //       break
  //     case 'WALLET_CONNECT':
  //       type = 'walletconnect'
  //       break
  //     default:
  //       type = 'unknown'
  //   }
  //
  //   return {
  //     type,
  //     name,
  //     icon
  //   }
  // }
  //
  // private getSDKProperties(): { projectId: string; st: string; sv: string } {
  //   return ApiController._getSdkProperties()
  // }
  //
  private emit<Event extends keyof ZenexAuthentication.Events>(
    event: Event,
    data: ZenexAuthentication.Events[Event]
  ) {
    this.listeners[event].forEach(listener => listener(data))
  }
  //
  // private setAppKitAccountUser(session: ZenexAuthentication.SessionAccount) {
  //   const { email } = session
  //
  //   if (email) {
  //     Object.values(ConstantsUtil.CHAIN).forEach(chainNamespace => {
  //       ChainController.setAccountProp('user', { email }, chainNamespace)
  //     })
  //   }
  // }
}

export namespace ZenexAuthentication {
    export type Events = {
    sessionChanged: SIWXSession | undefined
  }

  export type Listener<Event extends keyof Events> = (event: Events[Event]) => void

  export type EventListeners = {
    [Key in keyof Events]: Listener<Key>[]
  }

}

// export namespace ZenexAuthentication {
//   export type ConstructorParams = {
//     /**
//      * The key to use for storing the session token in local storage.
//      * @default '@appkit/siwx-auth-token'
//      */
//     localAuthStorageKey?: string
//     /**
//      * The key to use for storing the nonce token in local storage.
//      * @default '@appkit/siwx-nonce-token'
//      */
//     localNonceStorageKey?: string
//     /**
//      * If false the wallet stays connected when user denies the signature request.
//      * @default true
//      */
//     required?: boolean
//   }
//
//
//
//   export type WalletInfo =
//     | {
//     type: 'walletconnect' | 'extension' | 'unknown'
//     name: string | undefined
//     icon: string | undefined
//   }
//     | { type: 'social'; social: string; identifier: string }
//
//   export type Events = {
//     sessionChanged: SIWXSession | undefined
//   }
//
//   export type Listener<Event extends keyof Events> = (event: Events[Event]) => void
//
//   export type EventListeners = {
//     [Key in keyof Events]: Listener<Key>[]
//   }
//
//   export type SessionAccount = {
//     aud: string
//     iss: string
//     exp: number
//     projectIdKey: string
//     sub: string
//     address: string
//     chainId: number | string
//     chainNamespace: ChainNamespace
//     caip2Network: string
//     uri: string
//     domain: string
//     projectUuid: string
//     profileUuid: string
//     nonce: string
//     email?: string
//     appKitAccount?: {
//       uuid: string
//       caip2_chain: string
//       address: string
//       profile_uuid: string
//       created_at: string
//       is_main_account: boolean
//       verification_status: null
//       connection_method: object | null
//       metadata: object
//       last_signed_in_at: string
//       signed_up_at: string
//       updated_at: string
//     }
//   }
// }
//
// /**
//  * Decodes a JWT token and returns its payload
//  * @param token - The JWT token to decode
//  * @returns The decoded payload or null if invalid
//  */
// function jwtDecode(token: string): Omit<ZenexAuthentication.SessionAccount, 'appKitAccount'> {
//   // Split the token into parts
//   const parts = token.split('.')
//
//   // Check if the token has the correct format (header.payload.signature)
//   if (parts.length !== 3) {
//     throw new Error('Invalid token')
//   }
//
//   // Decode the payload (second part)
//   const payload = parts[1]
//
//   if (typeof payload !== 'string') {
//     throw new Error('Invalid token')
//   }
//
//   // Convert base64url to base64
//   const base64 = payload.replace(/-/gu, '+').replace(/_/gu, '/')
//
//   // Add padding if needed
//   const padded = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=')
//
//   // Decode and parse the JSON
//   const decoded = JSON.parse(atob(padded))
//
//   return decoded
// }
